import styled from 'styled-components'

import Picture from '../../atoms/Picture'
import ActionButton from '../../atoms/ActionButton'
import Link from '../../atoms/Link'
import { mq, sizes } from '../../../theme'

export const Main = styled.aside`
  border-radius: 2rem;
  overflow: hidden;
  width: 100%;

  @media print {
    display: none;
  }
`

export const Brand = styled(Link)`
  display: flex;
  width: 100%;
  position: relative;
  flex-direction: column;

  padding: 18rem 2.5rem 6.6rem;
  &:not(:only-child) {
    padding: 15rem 2.5rem 4.6rem;
  }
  @media ${mq(sizes.tablet)} {
    padding: 21rem 4rem 7.6rem;
    &:not(:only-child) {
      padding: 15rem 4rem 4.6rem;
    }
  }
`

export const BackgroundImage = styled(Picture)`
  position: absolute;
  flex-shrink: 0;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.1);
  & img {
    object-fit: cover;
    object-position: bottom center;
    width: 100%;
    height: 100%;
    max-width: initial;
    max-height: initial;
  }
`
export const BrandContent = styled.div`
  position: relative;
  margin: 0;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  border-radius: 1rem;
  padding: 1rem 1rem 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`

export const LogoContainer = styled.div`
  display: flex;
  position: absolute;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  border-radius: 100%;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 12rem;
  height: 12rem;
  top: -10.4rem;
  @media ${mq(sizes.tablet)} {
    width: 16rem;
    height: 16rem;
    top: -13.4rem;
  }
`
export const Logo = styled(Picture)`
  & img {
    object-fit: contain;
    height: auto;
  }
  width: 8rem;
  height: 8rem;
  @media ${mq(sizes.tablet)} {
    width: 12rem;
    height: 12rem;
  }
`
export const BrandHeader = styled.h2`
  margin: 0;
`
export const BrandLabel = styled.div`
  ${({ theme }) => theme.textStyles.titleH5};
  color: ${({ theme }) => theme.colors.arapawa};
  position: relative;
`
export const BrandName = styled.div`
  ${({ theme }) => theme.textStyles.titleH4};
  color: ${({ theme }) => theme.colors.ruby};
  position: relative;
  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.titleH3};
  }
`
export const Button = styled(ActionButton)`
  position: absolute;
  bottom: -2.5rem;
`

export const Product = styled(Link)`
  background-color: ${({ theme }) => theme.colors.pureWhite};
  display: flex;
  width: 100%;
  padding: 1.5rem;
  gap: 2rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.offGreen};
  align-items: center;
  cursor: pointer;
  &:last-of-type {
    border-bottom: none;
  }
`
export const ProductImage = styled(Picture)`
  border-radius: 1rem;
  flex-shrink: 0;
  border-radius: 1rem;
  overflow: hidden;
  & img {
    display: block;
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
  width: 10rem;
  height: 10rem;
  @media ${mq(sizes.tablet)} {
    width: 12rem;
    height: 12rem;
    border-radius: 1.8rem;
  }
`
export const ProductContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  align-items: flex-start;
`
export const ProductName = styled.div`
  color: ${({ theme }) => theme.colors.bismark};
  ${({ theme }) => theme.textStyles.titleH5};
  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.titleH4};
  }
`
export const ProductLabel = styled.div`
  ${({ theme }) => theme.textStyles.textSmallStrong};
  color: ${({ theme }) => theme.colors.ruby};

  &:after {
    content: '›';
    margin-left: 0.5rem;
    transition: margin-left 0.2s;
  }
  ${Product}:hover & {
    &:after {
      margin-left: 0.8rem;
    }
  }
`
